import React from "react";
import GalleryItem from "../../components/gallery/GalleryItem";
import KYouthMasonryData from "../../data/gallery/KYouthMasonryData.json";

const KYouthGalleryGrid = () => {
  return (
    <div className="edu-gallery-grid-area masonary-wrapper-activation edu-section-gap-k-youth bg-image overflow-hidden">
      <div className="container">
        <div className="eduvibe-gallery-items row g-5 mt--5">
          {KYouthMasonryData.map((item) => (
            <div key={item.id} className="col-lg-4 col-md-6 col-12">
              <GalleryItem data={item} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default KYouthGalleryGrid;
